import React, { useState, useEffect } from 'react';
import BackBtn from "../../common/backBTN";
import { Link } from "react-router-dom";

function SecurityCenter({userData}) {
    const [modal, setModal] = useState(false);
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('balance');
        localStorage.removeItem('remote_id');
        localStorage.removeItem('username');
        localStorage.removeItem('exchangeToken');
        localStorage.removeItem('agent_code');
        window.location.href = '/home';
    };
    const phoneVerified = !!userData?.phone;
    const emailVerified = !!userData?.email;
    const nameVerified = !!userData?.name;
    const eWalletBind = !!userData?.session_id; // or your own logic

    
  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
  <div className="security-center">
    <div className="mc-header-wrap">
      <div id="mc-header" className="mc-navbar-blue mc-securityCenter mc-default-header am-navbar am-navbar-light">
       <BackBtn/>
        <div className="am-navbar-title">Security Center</div>
        <div className="am-navbar-right" />
      </div>
      <div className="am-whitespace am-whitespace-sm mc-whitespace" />
    </div>
     {!phoneVerified && !emailVerified && !nameVerified ? (
    <div className="am-flexbox am-flexbox-align-middle">
      <div className="flex-text-tips">
       Your account security level is Low，Please improve your safety information
      </div>
    </div>
     ):
     (
      <></>
     )
     }
    <div className="am-flexbox am-flexbox-align-middle">
      <div className="card-btm security-list">
        <div className="am-list">
          <div className="am-list-body">
            <Link to={"/personalInformation"} className="flex-list-item am-list-item am-list-item-middle">
              <div className="am-list-line">
                <div className="am-list-content">
                  <div className="flex-grad-one">
                    <svg className="am-icon am-icon-profile_91540dcb am-icon-lg flex-list-icon1 security-icon" color="#cccccc"><use xlinkHref="#profile_91540dcb" /></svg>
                  </div>
                  <div className="flex-list-con">
                    <p className="flex-list-header">
                      <span className="flex-list-text">Personal information</span>
                      {phoneVerified && emailVerified && nameVerified ? (
                       <span className="flex-list-icon">
                        <svg className="am-icon am-icon-cancal_462cf10f am-icon-xs flex-list-icon1 icon-complete"><use xlinkHref="#cancal_462cf10f" /></svg>
                        <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon"><use xlinkHref="#edit_0f6eb9f1" /></svg>
                      </span>
                       ) : (
                      <span className="flex-list-icon">
                        <svg className="am-icon am-icon-unsett_c1731e83 am-icon-xs flex-list-icon1 icon-complete flex-list-icon-unsett"><use xlinkHref="#unsett_c1731e83" /></svg>
                        <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon"><use xlinkHref="#edit_0f6eb9f1" /></svg>
                      </span>
    )}
                    </p>
                    <p className="flex-list-title flex-list-desc">Complete personal information.</p>
                  </div>
                  <div className="flex-grad-arrows">
                    <svg className="am-icon am-icon-rightarrows_e029c01f am-icon-md" color="#A6A6A6"><use xlinkHref="#rightarrows_e029c01f" /></svg>
                  </div>
                </div>
              </div>
              
            </Link>
            <Link to={"/ewalletList"} className="flex-list-item am-list-item am-list-item-middle">
              <div className="am-list-line">
                <div className="am-list-content">
                  <div className="flex-grad-one">
                    <svg className="am-icon am-icon-bindEwallet_ee5bf137 am-icon-lg flex-list-icon1 security-icon" color="#cccccc"><use xlinkHref="#bindEwallet_ee5bf137" /></svg>
                  </div>
                  <div className="flex-list-con">
                    <p className="flex-list-header">
                      <span className="flex-list-text">Bind E-wallet</span>
                         {eWalletBind ? (
                       <span className="flex-list-icon">
                        <svg className="am-icon am-icon-cancal_462cf10f am-icon-xs flex-list-icon1 icon-complete"><use xlinkHref="#cancal_462cf10f" /></svg>
                        <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon"><use xlinkHref="#edit_0f6eb9f1" /></svg>
                      </span>
                      ) : (
                        <span className="flex-list-icon">
                        <svg className="am-icon am-icon-unsett_c1731e83 am-icon-xs flex-list-icon1 icon-complete flex-list-icon-unsett"><use xlinkHref="#unsett_c1731e83" /></svg>
                        <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon"><use xlinkHref="#edit_0f6eb9f1" /></svg>
                      </span>
                    )}
                    </p>
                    <p className="flex-list-title flex-list-desc">Bind E-wallet for withdrawal.</p>
                  </div>
                  <div className="flex-grad-arrows">
                    <svg className="am-icon am-icon-rightarrows_e029c01f am-icon-md" color="#A6A6A6"><use xlinkHref="#rightarrows_e029c01f" /></svg>
                  </div>
                </div>
              </div>
              <div className="am-list-ripple" style={{display: 'none'}} />
            </Link>
            <Link to="/changePassword" className="flex-list-item am-list-item am-list-item-middle">
              <div className="am-list-line">
                <div className="am-list-content">
                  <div className="flex-grad-one">
                    <svg className="am-icon am-icon-otherLock_79d1fd21 am-icon-lg flex-list-icon1 security-icon" color="#cccccc"><use xlinkHref="#otherLock_79d1fd21" /></svg>
                  </div>
                  <div className="flex-list-con">
                    <p className="flex-list-header">
                      <span className="flex-list-text">Change login password</span>
                      <span className="flex-list-icon">
                        <svg className="am-icon am-icon-cancal_462cf10f am-icon-xs flex-list-icon1 icon-complete"><use xlinkHref="#cancal_462cf10f" /></svg>
                        <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon"><use xlinkHref="#edit_0f6eb9f1" /></svg>
                      </span>
                    </p>
                    <p className="flex-list-title flex-list-desc">Recommended letter and number combination</p>
                  </div>
                  <div className="flex-grad-arrows">
                    <svg className="am-icon am-icon-rightarrows_e029c01f am-icon-md" color="#A6A6A6"><use xlinkHref="#rightarrows_e029c01f" /></svg>
                  </div>
                </div>
              </div>
              <div className="am-list-ripple" style={{display: 'none'}} />
            </Link>
            
            <div onClick={() => setModal(true)} className="flex-list-item am-list-item am-list-item-middle">
              <div className="am-list-line">
                <div className="am-list-content">
                  <div className="flex-grad-one">
                    <svg className="am-icon am-icon-logout_aae7786e am-icon-lg flex-list-icon1 security-icon" color="#cccccc"><use xlinkHref="#logout_aae7786e" /></svg>
                  </div>
                  <div className="flex-list-con">
                    <p className="flex-list-header"><span className="flex-list-text">Logout</span></p>
                    <p className="flex-list-title flex-list-desc">Logout safely</p>
                  </div>
                  <div className="flex-grad-arrows" />
                </div>
              </div>
              <div className="am-list-ripple" style={{display: 'none'}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
   {modal && (
        <>
    <div  onClick={() => setModal(false)} className="am-modal-mask" />
    <div tabIndex={-1} className="am-modal-wrap" role="dialog" aria-labelledby="rcDialogTitle0">
      <div role="document" className="am-modal am-modal-transparent" style={{width: '5.4rem', height: 'auto'}}>
        <div className="am-modal-content">
          <div className="am-modal-header"><div className="am-modal-title" id="rcDialogTitle0">Confirmation</div></div>
          <div className="am-modal-body">
            <div style={{zoom: 1, overflow: 'hidden'}}><div className="change-modal-title">Are you sure you want to logout?</div></div>
          </div>
          <div className="am-modal-footer">
            <div className="am-modal-button-group-h am-modal-button-group-normal" role="group"><Link  onClick={() => setModal(false)} className="am-modal-button" role="button">Cancel</Link><Link onClick={logout} className="am-modal-button" role="button">OK</Link></div>
          </div>
        </div>
        <div tabIndex={0} style={{width: '0px', height: '0px', overflow: 'hidden'}}>sentinel</div>
      </div>
    </div>
  </>
    )}
</div>

  );
}
export default SecurityCenter;